module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', [_c('div', {
    staticClass: "yu-amount",
    attrs: {
      "data-com": "YuAmount"
    }
  }, [_c('YuButton', {
    staticClass: "yu-amount-btn yu-amount-minus",
    attrs: {
      "disabled": _vm.nVal === _vm.min
    },
    on: {
      "click": _vm.fnMinus
    }
  }, [_c('YuIcon', {
    attrs: {
      "name": "minus"
    },
    slot: "icon"
  })], 1), _vm._v(" "), _c('input', {
    key: _vm.mark,
    staticClass: "yu-amount-ipt",
    attrs: {
      "type": "number",
      "min": _vm.min,
      "max": _vm.max
    },
    domProps: {
      "value": _vm.nVal
    },
    on: {
      "change": _vm.fnChange
    }
  }), _vm._v(" "), _c('YuButton', {
    staticClass: "yu-amount-btn yu-amount-add",
    attrs: {
      "disabled": _vm.nVal >= _vm.max
    },
    on: {
      "click": _vm.fnAdd
    }
  }, [_c('YuIcon', {
    attrs: {
      "name": "add"
    },
    slot: "icon"
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6d0f318","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/YouUI/Amount/Amount.vue
// module id = 295
// module chunks = 0